/**
 * @fileoverview API client for form schema operations
 * @module services/apiClient
 * 
 * Provides axios-like interface for API calls.
 */

import { apiService } from './apiService';

/**
 * API client with axios-like interface
 */
export const apiClient = {
  get: async (url: string) => {
    const data = await apiService.get(url);
    return { data };
  },
  post: async (url: string, body: any) => {
    const data = await apiService.post(url, body);
    return { data };
  },
  put: async (url: string, body: any) => {
    const data = await apiService.put(url, body);
    return { data };
  },
  delete: async (url: string, options?: { data?: any }) => {
    const data = await apiService.delete(url);
    return { data };
  },
};
